import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';


const BdTongFieldin = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchCheck1: "",
        searchCheck2: "",
        searchGrdc: '',
        searchLoca: '',
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? '1' : "") : value
        };
        setSearchParams(newParams);
    };


    const dataHead = ['의료기관명', '종별', '지역', '기관수', '환자수', '내원시간', '환자번호', '입력완료', '성명', '나이', '성별', '보험유형', '기관번호', '면허번호', '발병일자', '발병시간', '내원사유', '의도성', '손상기전', '내원경로', '내원수단', '주증상', '응급증상유무', '내원시반응', '수축기혈압', '이완기혈압', '분당맥박수', '분당호흡수', '체온', '응급진료결과', '주진료과', '퇴실일자', '퇴실시간', '기타사유TEXT', '교통사고정보', '진단코드', '응급실내검사,처치,수술', '전원보낸의료기관', '재난번호', '구급일지일련번호', '전원보낼의료기관종류'];
    const dataColumn = ['TNAME', 'EMCTYPE', 'EMCLOCA', 'EMCCOUNT', 'RECCOUNT', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12', 'TT13', 'TT14', 'TT15', 'TT16', 'TT17', 'TT18', 'TT19', 'TT20', 'TT21', 'TT22', 'TT23', 'TT24', 'TT25', 'TT26', 'TT27', 'TT28', 'TT29', 'TT30', 'TT31', 'TT32', 'TT33', 'TT34', 'TT35', 'TT36'];
    const apiCall = '/ptmiapi/monitoring/bdtongfieldin_search.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "응급실정보 입력률";
    const excelHead = [];
    const mergeConfig = [{ key: 'TNAME', row: null }, { key: 'EMCTYPE', row: 2, nullable: 'true' }, { key: 'EMCLOCA', row: 2, nullable: 'true' }, { key: 'EMCCOUNT', row: 2 }]

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="17%" />
                        <col width="10%" />
                        <col width="17%" />
                        <col width="10%" />
                        <col width="26%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                            <th>내원일시</th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div className='flex gap-2'>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                    <span>
                                        <input type="checkbox" id="searchCheck2" name="searchCheck2" checked={searchParams.searchCheck2 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck2">실시간 데이터 기준</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main>
    )
}

export default BdTongFieldin;